import React from 'react'
import { t } from '@lingui/core/macro'
import InputForm from '../InputForm/InputForm'
import CountrySelector from '../FormSelect/CountrySelect'
import { ValidationErrors } from '../../hooks/useFormValidation'
import { PaymentMethodField } from '../../types/paymentPageInfo'
import { getPaymentMethodExtraField } from '../../types/paymentMethod'
import styles from './ExtraFields.module.css'

interface ExtraFieldsProps {
    extraFields: PaymentMethodField[]
    data: Record<string, string>
    errors: ValidationErrors
    handleExtraFieldChange: (name: string, value: string) => void
}

const ExtraFields = ({ extraFields, data, errors, handleExtraFieldChange }: ExtraFieldsProps) => {
    const getInputType = (fieldName: string) => {
        const field = getPaymentMethodExtraField(fieldName)

        if (field?.type === 'date') return 'date'
        if (fieldName === 'phone') return 'tel'
        if (fieldName === 'email') return 'email'

        return 'text'
    }

    return (
        <div className={styles.extraSection}>
            <h3 className={styles.sectionTitle}>{t`Дополнительная информация`}</h3>
            <div className={styles.extraFields}>
                {extraFields.map(field => (
                    field.editable && (
                        field.name === 'country' ? (
                            <CountrySelector
                                key={field.name}
                                label={(getPaymentMethodExtraField(field.name)?.label || field.name) + ' *'}
                                value={data[field.name] || ''}
                                onChange={(value) => handleExtraFieldChange(field.name, value)}
                                errorMessage={errors[field.name] || undefined}
                            />
                        ) : (
                            <InputForm
                                key={field.name}
                                label={(getPaymentMethodExtraField(field.name)?.label || field.name) + ' *'}
                                type={getInputType(field.name)}
                                name={field.name}
                                value={data[field.name] || ''}
                                placeholder=""
                                onChange={(e) => handleExtraFieldChange(field.name, e.target.value)}
                                maxLength={50}
                                errorMessage={errors[field.name] || undefined}
                            />
                        )
                    )
                ))}
            </div>
        </div>
    )
}

export default ExtraFields
